import { useState, useEffect } from 'react';
import styles from './RoboKidsPage.module.css';

export default function RoboKidsPage1() {
  const [guardianName, setGuardianName] = useState('');
  const [email, setEmail] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [childName, setChildName] = useState('');
  const [childAge, setChildAge] = useState('');
  const [startDate, setStartDate] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [slideshowIndex, setSlideshowIndex] = useState(0);
  const [secondSlideshowIndex, setSecondSlideshowIndex] = useState(0);

  const placeholderImages = [
    '/images/robokids1.png',
    '/images/robokids2.png',
    '/images/robokids3.png'
  ];

  const secondSlideshowImages = [
    '/images/level1.png',
    '/images/level1.png'
  ];

 const availableDates = ['2026-02-10', '2026-02-11', '2026-02-12', '2026-02-13'];

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideshowIndex((prev) => (prev + 1) % placeholderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondSlideshowIndex((prev) => (prev + 1) % secondSlideshowImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const formData = {
      guardianName,
      childName,
      childAge,
      email,
      addressLine1: address1,
      addressLine2: address2,
      city,
      state,
      zipCode: zip,
      startDate,
      classType: 'basic'
    };

    try {
      const response = await fetch(
        'https://vgiqj6ha4n5pewmu4zkwhsac740nucsz.lambda-url.us-east-1.on.aws/',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        }
      );

      const data = await response.json();

      if (response.ok && data.checkoutUrl) {
        // ✅ Save registration data for use in success/waiver page
        sessionStorage.setItem('roboKidsWaiverSession', JSON.stringify(formData));
        // ✅ Redirect to Stripe (no query string!)
        window.location.href = data.checkoutUrl;
      } else {
        alert(data.message || 'Registration failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting registration:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.roboKidsWrapper}>
      {/* Left column: form */}
      <div className={styles.leftColumn}>
        <h2>Register for Robo Kids Beginner level Class!</h2>
        <form className={styles.form} onSubmit={handleRegister}>
          <label>Guardian Name:</label>
          <input type="text" required value={guardianName} onChange={(e) => setGuardianName(e.target.value)} />
          <label>Email:</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <label>Address Line 1:</label>
          <input type="text" required value={address1} onChange={(e) => setAddress1(e.target.value)} />
          <label>Address Line 2 (optional):</label>
          <input type="text" value={address2} onChange={(e) => setAddress2(e.target.value)} />
          <label>City:</label>
          <input type="text" required value={city} onChange={(e) => setCity(e.target.value)} />
          <label>State:</label>
          <input type="text" required value={state} onChange={(e) => setState(e.target.value)} />
          <label>ZIP Code:</label>
          <input type="text" required pattern="\d{5}" value={zip} onChange={(e) => setZip(e.target.value)} />
          <label>Child’s First Name:</label>
          <input type="text" required value={childName} onChange={(e) => setChildName(e.target.value)} />
          <label>Child’s Age:</label>
          <input type="number" required min="5" value={childAge} onChange={(e) => setChildAge(e.target.value)} />
          <label>Choose Class Start Date:</label>
          <select required value={startDate} onChange={(e) => setStartDate(e.target.value)}>
            <option value="">Select a date</option>
            {availableDates.map((date) => (
              <option key={date} value={date}>
                {new Date(date + 'T00:00:00').toLocaleDateString(undefined, {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </option>
            ))}
          </select>

          <button type="submit" disabled={submitting} className={styles.registerButton}>
            {submitting ? 'Processing...' : 'Proceed to Payment'}
          </button>
        </form>
      </div>

      {/* Middle: slideshow */}
      <div className={styles.slideshowColumn}>
        <div className={styles.slideshowContainer}>
          <img
            src={placeholderImages[slideshowIndex]}
            alt={`Slideshow ${slideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p>Enroll your child today!</p>
        </div>
        <div className={styles.slideshowContainer}>
          <img
            src={secondSlideshowImages[secondSlideshowIndex]}
            alt={`Kit image ${secondSlideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p style={{ fontSize: '0.75rem', color: '#777' }}>
            Actual kit contents may vary slightly — essential components remain the same.
          </p>
        </div>
      </div>

      {/* Right column: description */}
      <div className={styles.rightColumn}>
      
      <h2>Basic Level: AI & Robotics Discovery – $400</h2>
<p>
  Perfect for young innovators or first-time builders, this course introduces kids 
  to the world of AI-powered circuits and creative robotics. We’ll ship them 
  a complete electronics + robotics kit and guide them step-by-step — live on Video call!
</p>

<ul>
  <li><strong>What's Included:</strong>
    <ul>
      <li>Electronics starter pack: LEDs, resistors, jumper wires, and breadboard</li>
      <li>Motors, servo modules, and controller board with USB for programming</li>
      <li>Chassis pieces, wheels, and hardware for robot assembly</li>
      <li>Kid-friendly tools: screwdriver, wire strippers, adhesive, screws</li>
      <li>AI workbook with coding + robotics challenges</li>
    </ul>
  </li>
  <li><strong>Course Format:</strong> 6-week program with live Zoom sessions</li>
  <li><strong>Beginner Topics:</strong>
    <ul>
      <li>What is AI? How computers “think” with logic</li>
      <li>Building circuits: LED control, blinking patterns, and signals</li>
      <li>Motor control: movement mechanics and direction with AI logic</li>
      <li>Robot assembly + AI programming: your first autonomous robot</li>
    </ul>
  </li>
</ul>

<div className={styles.faqBox}>
  <h3>❓ Frequently Asked Questions</h3>
  <details><summary><strong>What age group is this for?</strong></summary><p>Kids ages 6–13. Teens can move up to Intermediate AI Robotics.</p></details>
  <details><summary><strong>Any experience needed?</strong></summary><p>Nope! 100% beginner-friendly.</p></details>
  <details><summary><strong>What do we need at home?</strong></summary><p>A laptop/desktop and some desk space.</p></details>
  <details><summary><strong>Are the classes live?</strong></summary><p>Yes — taught live, with recordings available upon request.</p></details>
  <details><summary><strong>Is the kit safe?</strong></summary><p>Yes. All components are kid-safe; adult supervision recommended for younger learners.</p></details>
</div>

      </div>
    </div>
  );
}
